/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeEmailSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Email Setting Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *
 *  Created:    Saturday, August 27, 2022 - 05:58:16 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const EMAILSETTING_LIST_CONTAINER_LOADED = 'EMAILSETTING_LIST_CONTAINER_LOADED';
export const EMAILSETTING_LIST_CONTAINER_UNLOADED = 'EMAILSETTING_LIST_CONTAINER_UNLOADED';
export const EMAILSETTING_LIST_TABLE_LOADED = 'EMAILSETTING_LIST_TABLE_LOADED';
export const EMAILSETTING_LIST_TABLE_UNLOADED = 'EMAILSETTING_LIST_TABLE_UNLOADED';

export const EMAILSETTING_LIST_CHANGE_GROUP = 'EMAILSETTING_LIST_CHANGE_GROUP';
export const EMAILSETTING_SELECT_ROW = 'EMAILSETTING_SELECT_ROW';

export const EMAILSETTING_ADD = 'EMAILSETTING_ADD';
export const EMAILSETTING_EDIT = 'EMAILSETTING_EDIT';
export const EMAILSETTING_DELETE = 'EMAILSETTING_DELETE';
export const EMAILSETTING_OPEN_WARNING = 'EMAILSETTING_OPEN_WARNING';
export const EMAILSETTING_CLOSE_WARNING = 'EMAILSETTING_CLOSE_WARNING';
export const EMAILSETTING_DELETE_DISABLE = 'EMAILSETTING_DELETE_DISABLE';
export const EMAILSETTING_VIEW_CHILD_ITEMS = 'EMAILSETTING_VIEW_CHILD_ITEMS';

export const EMAILSETTING_EDIT_CONTAINER_LOADED = 'EMAILSETTING_EDIT_CONTAINER_LOADED';
export const EMAILSETTING_EDIT_CONTAINER_UNLOADED = 'EMAILSETTING_EDIT_CONTAINER_UNLOADED';
export const EMAILSETTING_EDIT_FORM_LOADED = 'EMAILSETTING_EDIT_FORM_LOADED';
export const EMAILSETTING_EDIT_FORM_UNLOADED = 'EMAILSETTING_EDIT_FORM_UNLOADED';

export const EMAILSETTING_SET_GROUP_SELECT = 'EMAILSETTING_SET_GROUP_SELECT';
export const EMAILSETTING_EDIT_DATA_LOAD = 'EMAILSETTING_EDIT_DATA_LOAD';

export const EMAILSETTING_EDIT_CONTAINER_SUBMIT = 'EMAILSETTING_EDIT_CONTAINER_SUBMIT';
export const EMAILSETTING_EDIT_CONTAINER_CANCEL = 'EMAILSETTING_EDIT_CONTAINER_CANCEL';